export const CREATE_NEWS = 'NEWS/CREATE';
export const LOAD_PERSONAL_NEWS = 'NEWS_PERSONAL/LOAD';
export const LOAD_GENERAL_NEWS = 'NEWS_GERENAL/LOAD';
export const UPDATE_GENERAL_NEWS = 'NEWS_GERENAL/UPDATE';
export const LIKE_NEWS = 'NEWS/LIKE';
export const NEWS_ADD_COMMENT = 'NEWS/ADD_COMMENT';
export const DELETE_NEWS = 'NEWS/DELETE';
export const LOADING_STATUS = 'NEWS/LOADING_STATUS';
